import { MANAGE_ORDER_DETAIL, MANAGE_ORDER_LIST } from "./types";

export const manageOrderList = (data,onSuccess, onError) => {
  return {
    type: MANAGE_ORDER_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const manageOrderDetail = (id, onSuccess, onError) => {
  return {
    type: MANAGE_ORDER_DETAIL,
    id,
    onSuccess,
    onError,
  };
};
